import React from "react";
import { goFullWebView } from "lib/utils";

const Home = ({ history }) => {
  if (process.env.REACT_APP_ENVIRONMENT === "prod") {
    window.location.href = "https://dcx.b-dan.com";
    return null;
  }

  const go = (url) => {
    if (window.wallet) {
      goFullWebView({ url, method: "get" });
    } else {
      history.push(url);
    }
  };

  return (
    <div>
      <ul>
        <li onClick={() => go("/ocbPw")}>ocb Password 페이지 가기</li>
        <li onClick={() => go("/main")}>메인으로 가기</li>
        <li onClick={() => go("/buy")}>매수 페이지 가기</li>
        <li onClick={() => go("/auth")}>임시로그인 페이지로 이동</li>
        <li onClick={() => go("/signup-test")}>회원가입 테스트로 이동</li>
        <li onClick={() => go("/leave-test")}>회원탈퇴 테스트로 이동</li>
        <li onClick={() => go("/alert")}>테스트 팝업</li>
      </ul>
    </div>
  );
};

export default Home;
